import React, {createContext, useState, useEffect, ReactNode} from "react";
import { profileService } from "../api/profileService/profileService";
import { IApiServiceResponse,  } from "../types/api";
import { BusinessProfile, LegacyCode } from "../types/profile";
//Definizione tipo contesto
interface BusinessProfileContexType{
    businessProfile: BusinessProfile ;
    loading: boolean;
    error: string | null;
    legacyData:LegacyCode[];
    isLoaded:boolean;
}

const BusinessProfileContex = createContext<BusinessProfileContexType | undefined>(undefined);

export const BusinessProfileProvider: React.FC<{children: ReactNode}> = ({children}) =>{
    const [businessProfile, setBusinessProfile] = useState<BusinessProfile | undefined>(undefined)
    const [legacyData, setLegacyData] = useState<LegacyCode[]>([]); 
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [isLoaded, setIsLoaded] = useState(false); // Nuovo stato
    const [isFetching, setIsFetching] = useState(false); // Flag per evitare chiamate duplicate

    useEffect(() => {
        const storedLegacyData = sessionStorage.getItem("legacyData");
        if (storedLegacyData) {
          setLegacyData(JSON.parse(storedLegacyData));
          setIsLoaded(true);
        }

        const storedBusinessProfile = sessionStorage.getItem("businessProfile");
        if (storedBusinessProfile) {
          setBusinessProfile(JSON.parse(storedBusinessProfile));
          setLoading(false);
          return; // Se abbiamo già i dati in sessionStorage, non facciamo la chiamata
        }

        // Controlla se i dati sono già disponibili dal actionSidebarLoader
        const checkForExistingData = () => {
          // Aspetta un po' per permettere al actionSidebarLoader di caricare i dati
          setTimeout(() => {
            const storedBusinessProfile = sessionStorage.getItem("businessProfile");
            if (storedBusinessProfile) {
              const profile = JSON.parse(storedBusinessProfile);
              setBusinessProfile(profile);
              setLegacyData(profile.legacycodes);
              setLoading(false);
            } else {
              // Solo se non ci sono dati e non stiamo già facendo una chiamata, fai la chiamata API
              if (!isFetching) {
                fetchBusinessProfile();
              }
            }
          }, 100);
        };

        const fetchBusinessProfile = async () => {
          // Evita chiamate duplicate
          if (isFetching) {
            console.log('BusinessProfile: Chiamata API già in corso, skip');
            return;
          }
          
          try {
            setIsFetching(true);
            setLoading(true);
            console.log('BusinessProfile: Iniziando chiamata API');
            const response: IApiServiceResponse = await profileService.getBusinessProfile();
            if (response.success) {
              const profile = response.responseBody as BusinessProfile;
              setBusinessProfile(profile);
              setLegacyData(profile.legacycodes); // Salva i dati di legacycodes
              sessionStorage.setItem("legacyData", JSON.stringify(profile.legacycodes));
              sessionStorage.setItem("businessProfile", JSON.stringify(profile)); // Salva il profilo aziendale
              console.log('BusinessProfile: Dati caricati con successo');
            } else {
              setError("Errore nel recupero del profilo aziendale");
            }
          } catch (err) {
            setError("Errore durante la richiesta al server");
          } finally {
            setLoading(false);
            setIsFetching(false);
          }
        };

        checkForExistingData();
    }, [isFetching]);

  // Gestione del caso in cui il businessProfile non sia disponibile
  if (!businessProfile && !loading && !error) {
    return <div>Errore: profilo aziendale non trovato.</div>;
  }

    return(
        <BusinessProfileContex.Provider value={{businessProfile:businessProfile as BusinessProfile, loading, error,legacyData,isLoaded}}>
            {children}
        </BusinessProfileContex.Provider>
    )
};

export default BusinessProfileContex;


 